// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { isFeedbackOnlyAccess, isFullAccess } from '../../../../common/permissions/permissionUtil';

// Selectors
import { currentBoardUnconstrainedUserPermissions } from '../../../utils/permissions/elementPermissionsSelector';
import { getUrlAbGroup, getUrlRegistrationEntryPoint } from '../../../app/routingSelector';

// Components
import Register from './Register';
import Icon from '../../../components/icons/Icon';

// Constants
import { REGISTRATION_ENTRY_POINT } from '../../../../common/users/userConstants';

const mapStateToProps = createStructuredSelector({
    unconstrainedPermissions: currentBoardUnconstrainedUserPermissions,
    guestAbGroup: getUrlAbGroup,
    registrationEntryPoint: getUrlRegistrationEntryPoint,
});

const getHeadingText = (unconstrainedPermissions) => {
    if (isFullAccess(unconstrainedPermissions)) return 'Sign up to edit this board';
    if (isFeedbackOnlyAccess(unconstrainedPermissions)) return 'Sign up to add feedback';
    return 'Sign up to Milanote';
};

/**
 * Same as the normal register modal, it just changes its heading text and logo
 */
const AppRegister = (props) => {
    const { registrationEntryPoint, unconstrainedPermissions, close } = props;

    const headingText = getHeadingText(unconstrainedPermissions);

    const preventClose = registrationEntryPoint === REGISTRATION_ENTRY_POINT.PUBLIC_EDIT_REGISTRATION;

    return (
        <Register className="AppRegister" {...props} close={preventClose ? null : close}>
            <div className="logo">
                <Icon name="milanote-logo-medium" />
            </div>

            <div className="heading">
                <h2>{headingText}</h2>
            </div>
        </Register>
    );
};

AppRegister.propTypes = {
    unconstrainedPermissions: PropTypes.number,
    close: PropTypes.func,
    guestAbGroup: PropTypes.string,
    registrationEntryPoint: PropTypes.string,
};

export default connect(mapStateToProps)(AppRegister);
